export const imageData = {
  color: { 
    title: "Color",
    total: 5,
    link: "/character/color"
  },
  clothes: {
    title: "Clothes",
    total: 6,
    link: "/character/clothes",
  },
  face: {
    title: "Face",
    total: 3,
    link: "/character/face",
  },
  hair: { 
    title: "Hair", 
    total: 6, 
    link: "/character/hair" },
};
